import React from "react";
import {TitleLayout} from "~/apps/core/ui/TitleLayout";
import {Box, Grid, Typography} from "@mui/material";
import {useGetReconciliation} from "~/apps/packages/finance/hooks";
import {useHistory} from "react-router-dom";
import {
    ReconciliationDetailsForm,
    ReconciliationDetailsFormProps
} from "~/apps/packages/finance/components/ReconciliationDetailsForm";
import {Dialog} from "~/components/Dialog";
import {Done} from "@mui/icons-material";
import {
    DetailsRequestSuccessModal
} from "~/apps/packages/finance/components/DetailsRequestSuccessModal/DetailsRequestSuccessModal";



export const ReconciliationDetailsPage = () => {
    const history = useHistory();
    const [getReconciliation, {loading}] = useGetReconciliation();
    const [isSubmitSuccess, setIsSubmitSuccess] = React.useState(false);
    const handleSubmit: ReconciliationDetailsFormProps["onSubmit"] = async (values) => {
         getReconciliation({
            dateFrom: values.dates[0],
            dateTo: values.dates[1],
            email: values.email
        })
             .then(() => setIsSubmitSuccess(true))
    };

    return (
        <TitleLayout title={"Детализация сверки"}>
            <Box pt={2}>
                <ReconciliationDetailsForm onSubmit={handleSubmit} loading={loading} />
            </Box>
            <DetailsRequestSuccessModal isOpen={isSubmitSuccess} onClose={() => setIsSubmitSuccess(false)} />
        </TitleLayout>
    )
}
